import { render, staticRenderFns } from "./outboundUdiReview.vue?vue&type=template&id=5a12664e&"
import script from "./outboundUdiReview.vue?vue&type=script&lang=js&"
export * from "./outboundUdiReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports